import React from "react"
import { RichText } from "prismic-reactjs"

import { Element, ElementProps, Text } from "legacy/components/shared/base"
import { Maybe } from "types/Maybe"
import { PrismicPageDataBodyHeroPrimaryType } from "types/__generated__/gatsby-graphql"
import { mapFontSize } from "src/legacy/utils"

interface OwnProps {
  children: Maybe<React.ReactChild | React.ReactChild[]>
  data: Maybe<PrismicPageDataBodyHeroPrimaryType>
  textColor: Maybe<string>
}

export type HeroTextProps = OwnProps & ElementProps

const HeroText: React.FC<HeroTextProps> = ({
  children,
  data,
  textColor,
  ...heroTextProps
}): React.ReactElement | null => {
  if (!data) return null

  const color = textColor || "navy"
  const { eyebrow, headline, headline_font_size, intro } = data
  const headlineMargin = intro ? ["20", "35"] : ["45", "50"]
  const headlineFontSize = mapFontSize("header", headline_font_size)

  return (
    <Element {...heroTextProps}>
      {eyebrow && (
        <Text
          color={color}
          fontSize={["13", "text.captionCaps"]}
          lineHeight={["22px", "1.8"]}
          mb={["50"]}
          variant="captionCaps"
        >
          {eyebrow}
        </Text>
      )}
      <Text
        as="div"
        color={color}
        fontSize={["36", headlineFontSize[1]]}
        lineHeight="1.37"
        mb={headlineMargin}
        mx="auto"
        variant="header"
      >
        <RichText render={headline?.richText} />
      </Text>
      {children}
      {intro && (
        <Text
          as="h2"
          color={color}
          fontSize={["17", "text.body"]}
          lineHeight={["28px", "1.8"]}
          m={["0 auto", "0 auto"]}
        >
          {intro}
        </Text>
      )}
    </Element>
  )
}

export default HeroText
